import { SakaiPager } from "./src/SakaiPager.js";

!customElements.get("sakai-pager") && customElements.define("sakai-pager", SakaiPager);
